module.exports = __webpack_public_path__ + "img/10.0f12af8e.png";